<template>
<div class="new-order-form" :class="{ 'modal-display' : ismodal}">

	<Preloader v-show="!initializationDone" />

	<div v-if="initializationDone">

		<!-- begin form -->
		<div v-if="showForm" v-show="!showReview" class="m-3 mx-auto" style="max-width: 700px;">

			<v-form ref="form" v-model="valid" lazy-validation>

				<div class="mt-2 mb-2 px-2">
					<v-icon class="mr-2">mdi-lightbulb-on-outline</v-icon>
					<small>{{ $t('compNewOrderForm.introTxt') }}</small>
				</div>

				<v-row dense class="mt-2">

					<!-- Token to Sell -->
					<v-col cols="12" md="6">
						<v-select class="mx-2"
							v-model="input.makerAssetAddress"
							:items="inputOptions.makerAssetAddress"
							item-text="text"
							item-value="value"
							:label="$t('common.orderForm.label.tokenToSell')"
							:hint="input.makerAssetAddress ? $t('common.noun.balance') + ': ' + formatAmountNumber(account.balanceByAddress[input.makerAssetAddress]) : ''"
							:rules="rules.makerAssetAddress"
							@change="handleMakerTokenChange"
							persistent-hint
							outlined dense
						></v-select>
					</v-col>

					<!-- Token to buy -->
					<v-col cols="12" md="6">
						<v-select class="mx-2"
							v-model="input.takerAssetAddress"
							:items="inputOptions.takerAssetAddress"
							item-text="text"
							item-value="value"
							:label="$t('common.orderForm.label.tokenToBuy')"
							:hint="input.takerAssetAddress ? $t('common.noun.balance') + ': ' + formatAmountNumber(account.balanceByAddress[input.takerAssetAddress]) : ''"
							:rules="rules.takerAssetAddress"
							@change="handleTakerTokenChange"
							persistent-hint
							outlined dense
						></v-select>
					</v-col>

				</v-row>

				<v-row dense v-if="input.makerAssetAddress && input.takerAssetAddress" justify="center" class="mb-2">
					<!-- Price Diplay Options -->
					<v-col cols="12" md="8">
						<v-select
							:items="priceDisplayOptions"
							v-model="input.priceDisplay"
							hide-details
							dense
							filled
							flat
							solo
							class="mx-2"
						></v-select>
					</v-col>
				</v-row>

				<v-row dense v-if="input.makerAssetAddress && input.takerAssetAddress" justify="center">
					<!-- priceMakerPerTaker -->
					<v-col v-if="input.priceDisplay === 'maker-per-taker'" cols="12" md="6">
						<v-text-field class="mx-2"
							outlined dense persistent-hint
							v-model.number.trim="input.priceMakerPerTaker"
							:label="$t('common.noun.price')"
							:prefix="'1 ' + takerAssetInfo.symbol + ' =  '"
							:suffix="makerAssetInfo.symbol"
							@input="handlePriceMakerPerTakerChange"
							:rules="rules.priceMakerPerTaker"
							:hint="input.priceTakerPerMaker ?
								'1 ' + makerAssetInfo.symbol + ' =  ' +
								+ formatAmountNumber(input.priceTakerPerMaker) + ' '
								+ takerAssetInfo.symbol
								: ''"
						></v-text-field>
					</v-col>

					<!-- priceMakerPerTaker -->
					<v-col v-if="input.priceDisplay === 'taker-per-maker'" cols="12" md="6">
						<v-text-field class="mx-2"
							outlined dense persistent-hint
							v-model.number.trim="input.priceTakerPerMaker"
							:label="$t('common.noun.price')"
							:prefix="'1 ' + makerAssetInfo.symbol + ' =  '"
							:suffix="takerAssetInfo.symbol"
							@input="handlePriceTakerPerMakerChange"
							:rules="rules.priceTakerPerMaker"
							:hint="input.priceMakerPerTaker ?
								'1 ' + takerAssetInfo.symbol + ' =  ' +
								+ formatAmountNumber(input.priceMakerPerTaker) + ' '
								+ makerAssetInfo.symbol
								: ''"
						></v-text-field>
					</v-col>

				</v-row>

				<v-row dense v-if="input.makerAssetAddress && input.takerAssetAddress">

					<!-- Amount to Sell -->
					<v-col cols="12" md="6">
						<v-text-field class="mx-2"
							outlined dense color="gray" persistent-hint
							:label="$t('common.orderForm.label.amountToSell')"
							v-model.number.trim="input.makerAssetAmount"
							:rules="rules.makerAssetAmount"
							type="number"
							placeholder=""
							:max="formatAmountNumber(maxMakerAssetAmount)"
							:suffix="makerAssetInfo.symbol"
							:hint="input.makerAssetAddress ?
							  $t('common.err.amount.max') + ': ' + formatAmountNumber(maxMakerAssetAmount) + ', '
								+ $t('common.noun.balance') + ': '
								+ formatAmountNumber(account.balanceByAddress[input.makerAssetAddress]) + ', '
								+ $t('common.noun.allowance') + ': '
								+ formatAllowanceNumber(account.allowanceByAddress[makerAssetInfo.address])
								: ''"
							@input="handleMakerAssetAmountChange"
						></v-text-field>
					</v-col>

					<!-- Amount to Buy -->
					<v-col cols="12" md="6">
						<v-text-field class="mx-2"
							outlined dense color="gray" persistent-hint
							:label="$t('common.orderForm.label.amountToBuy')"
							v-model.number.trim="input.takerAssetAmount"
							:rules="rules.takerAssetAmount"
							type="number"
							placeholder=""
							:suffix="takerAssetInfo.symbol"
							:hint="input.takerAssetAddress ?
								$t('common.noun.balance') + ': '
								+ formatAmountNumber(account.balanceByAddress[input.takerAssetAddress]) + ', '
								+ $t('common.noun.allowance') + ': '
								+ formatAllowanceNumber(account.allowanceByAddress[takerAssetInfo.address])
								: ''"
							@input="handleTakerAssetAmountChange"
						></v-text-field>
					</v-col>

				</v-row>

				<v-row dense v-if="input.makerAssetAddress && input.takerAssetAddress && input.makerAssetAmount && input.takerAssetAmount" justify="center">

					<!-- Choose whether to restrict taker -->
					<v-col cols="12" md="8">
						<v-select class="mx-2"
							:items="inputOptions.restrictTakerOptions"
							v-model="input.restrictTaker"
							hide-details
							dense
							filled
							solo
							flat
						></v-select>
					</v-col>

				</v-row>

				<v-row dense v-if="input.makerAssetAddress && input.takerAssetAddress && input.makerAssetAmount && input.takerAssetAmount && input.restrictTaker" justify="center">

					<!-- Choose whether to restrict taker -->
					<v-col cols="12" md="8">
						<v-text-field class="mx-2"
							outlined dense color="gray" persistent-hint
							:label="$t('common.orderForm.label.takerAccount')"
							v-model.trim="input.takerAddress"
							:rules="rules.takerAddress"
							clearable
							type="text"
							placeholder=""
						></v-text-field>
					</v-col>

				</v-row>

				<!-- expiration time -->
				<v-row dense v-if="input.makerAssetAddress && input.takerAssetAddress && input.makerAssetAmount && input.takerAssetAmount" justify="center" no-gutters class="mt-3">

					<!-- Enter time period -->
					<v-col cols="12" md="12" class="text-center" v-if="input.expirationTimeInputMethod === 'enter-period'">
						<div class="d-inline-block mr-2">
							{{ $t('common.orderForm.label.expirationTime') }}:
						</div>
						<div class="d-inline-block mr-2">
							<v-text-field
								v-model="input.expirationSelected.number"
		            style="width: 80px;"
		            type="number"
		            :rules="rules.expirationSelectedNum"
		            outlined dense
		          ></v-text-field>
		        </div>
		        <div class="d-inline-block mr-2">
		        	<v-select v-model="input.expirationSelected.period"
		        		style="width: 120px"
			          :items="inputOptions.expirationTimeSelectPeriods"
			          outlined dense
			        ></v-select>
		      	</div>
		      	<div class="d-inline-block">
		      		<v-icon @click="changeExpirationTimeInputMethod('use-picker')">
		      			mdi-calendar
		      		</v-icon>
		      	</div>
					</v-col>

					<!-- Date Time Picker -->
					<v-col v-if="input.expirationTimeInputMethod === 'use-picker'" cols="11" md="8">
						<v-datetime-picker
							outlined color="success"
							:label="$t('common.orderForm.label.expirationTime')"
							v-model="input.expirationTimeFromPicker"
							:textFieldProps="expirationTimeTextFieldConfig"
							:datePickerProps="expirationDatePickerConfig"
							:timePickerProps="expirationTimePickerConfig"
							:rules="rules.expirationTime"
							>
							<template slot="dateIcon">
								<v-icon>mdi-calendar</v-icon>
							</template>
							<template slot="timeIcon">
								<v-icon>mdi-clock-outline</v-icon>
							</template>
						</v-datetime-picker>
					</v-col>
					<v-col v-if="input.expirationTimeInputMethod === 'use-picker'" cols="1" md="1">
						<div class="ml-2 pt-4">
		      		<v-icon @click="changeExpirationTimeInputMethod('enter-period')">
		      			mdi-square-edit-outline
		      		</v-icon>
		      	</div>
		      </v-col>
				</v-row>

				<!-- Review button -->
				<div class="text-center">
					<v-btn color="secondary"
						@click="init" class="ma-2"
					>
							{{ $t('common.verb.reset') }}
					</v-btn>
					<v-btn v-show="inputComplete"
						color="success" class="ma-2"
						@click="showOrderReview"
						:disabled="!valid || loading"
					>
						{{ $t('compNewOrderForm.reviewOrder') }}
					</v-btn>
				</div>

			</v-form>

		</div>
		<!-- end form -->

		<!-- Begin order review -->
		<div v-if="showReview">
			<div class="title text-center">
				{{ $t('compNewOrderForm.reviewOrder') }}
			</div>

			<div v-if="!initializationDone || preparingOrder">
				<Preloader />
			</div>

			<div v-else>

				<div v-if="valid" class="m-2 mx-auto p-3 order-review-wrapper">

					<OrderSummary
	          :parsedOrder="parsedOrder"
	          :myaddress="myAddress" :myaccount="account"
	          :accounturl="networkConfig.accountURL"
	          :tokenurl="networkConfig.tokenURL"
	          :txurl="networkConfig.txURL"
	          viewonly
	        />

				</div>

				<div class="text-center my-3">

					<v-btn @click="hideOrderReview" class="ma-2">
						{{ $t('compNewOrderForm.btnModifyOrder') }}
					</v-btn>

					<v-btn @click="generateNewOrder" color="success" class="m-2"
						:disabled="!valid || loading">
						{{ $t('compNewOrderForm.btnSubmitOrder') }}
						<ButtonLoading v-show="loading" class="ml-3" />
					</v-btn>

				</div>

			</div>
		</div>
		<!-- End order review -->

		<!-- Begin waiting for network -->
		<div v-if="waitingForNetwork">

			<Preloader :text="$t('compNewOrderForm.btnSubmitOrderLoading') + '...'"  />

		</div>
		<!-- End  waiting for network -->


		<!-- Begin submission result -->
    <div v-else>

      <div v-show="error">
        <v-alert type="error">
          <strong>{{ $t('common.noun.errors') }}:</strong><br />
          {{ error }}
        </v-alert>
        <div class="text-center">
          <v-btn color="success" @click="init">{{ $t('common.verb.tryAgain') }}</v-btn>
        </div>
      </div>

      <div v-show="!error">

        <div v-show="showResult">

        	<v-alert type="success">
        		{{ $t('compNewOrderForm.successMessageShort') }}
        	</v-alert>

          <div v-if="!ismodal" class="text-center mb-3">
            <v-btn v-if="orderHash" color="success" class="ma-2" :to="{ name: 'MyOrders', params: { orderType: 'sent' } }">{{ $t('compNewOrderForm.btnViewOrderList') }}</v-btn>
            <v-btn color="success" @click="init">{{ $t('compNewOrderForm.btnCreateAnotherOrder') }}</v-btn>
          </div>

          <div v-if="ismodal" class="text-center mb-3">
            <v-btn v-if="orderHash" color="success" class="ma-2" :to="{ name: 'OrderDetails', params: { orderHash: orderHash } }">{{ $t('compNewOrderForm.btnViewOrder') }}</v-btn>
            <v-btn color="success" @click="emitCloseModal">{{ $t('common.verb.close') }}</v-btn>
          </div>

        </div>

      </div>

    </div>
    <!-- End  submission result -->

	</div>

	<SetProxyAllowance v-if="allowsetallowance"
		ref="setProxyAllowanceForm"

	/>

	<AddTokenTracking v-if="initializationDone"
		ref="addTokenTrackingForm"

	/>

</div>
</template>

<script>

import { config } from '@/config'
import Preloader from "@/components/Preloader"
import { ERC20TokenContract, OrderStatus } from '@0x/contract-wrappers'
import { BigNumber } from '@0x/utils'
import { Web3Wrapper } from '@0x/web3-wrapper'
import PendingTransaction from "@/components/PendingTransaction"
import {mapActions, mapGetters, mapState} from 'vuex'
import { findTokenByAddress, formatAmountNumber, formatAllowanceNumber, countDecimals, getUnixTimeFromISODate, getCurrentUnixTime, showDateTime } from '@/utils/utils'
import ButtonLoading from "@/components/ButtonLoading"
import AddTokenTracking from "@/components/AddTokenTracking"
import SetProxyAllowance from "@/components/SetProxyAllowance"
import OrderSummary from "@/components/OrderSummary"
import ERC20Token from "@/components/ERC20Token"
import AmountNumber from "@/components/AmountNumber"
import UserAddress from "@/components/UserAddress"
import { NULL_ADDRESS, NULL_BYTES, ZERO } from '@/config/constants'
import { generatePseudoRandomSalt, Order, signatureUtils } from '@0x/order-utils'
import { HttpClient } from '@0x/connect'

export default {
	name: 'NewOrderForm',
	components: {
		Preloader,
		AddTokenTracking,
		SetProxyAllowance,
		UserAddress,
		AmountNumber,
		ERC20Token,
		OrderSummary,
		ButtonLoading,
	},
	props: {
		tokenselection: { type: Object },
		allowaddtoken: { type: Boolean, default: false },
		allowsetallowance: { type: Boolean, default: false },
		ismodal: { type: Boolean, default: false },
	},
	data () {
		return {
			config: config,
			orderData: null,
			parsedOrder: null,
			valid: true,
			loopJob: null,
			currentUnixTime: null,
			input: {
				makerAddress: null,
				takerAddress: null,
				senderAddress: null,
				feeRecipientAddress: null,
				makerAssetAddress: null,
				takerAssetAddress: null,
				exchangeAddress: null,
				makerFee: null,
				takerFee: null,
				makerAssetAmount: null,
				takerAssetAmount: null,
				expirationTimeFromPicker: null,
				expirationTimeInputMethod: 'enter-period', // 'enter-period', 'use-picker'
				expirationSelected: {
					number: null,
					period: 'hour', // 'min', 'hour', 'day', 'week', 'month'
				},
				restrictTaker: false,
				priceDisplay: 'maker-per-taker',
				priceTakerPerMaker: null,
				priceMakerPerTaker: null
			},
			inputOptions: {
				makerAssetAddress: [],
				takerAssetAddress: [],
				minExpirationTime: null,
				currentTimeDisplay: null,
				restrictTakerOptions: [
					{ text: this.$t('common.orderForm.option.whoCanFill.anybody'), value: false },
					{ text: this.$t('common.orderForm.option.whoCanFill.selected'), value: true }
				],
				expirationTimeSelectPeriods: [
					{ value: 'min', text: this.$t('common.noun.timePeriod.minutes') },
					{ value: 'hour', text: this.$t('common.noun.timePeriod.hours') },
					{ value: 'day', text: this.$t('common.noun.timePeriod.days') },
					{ value: 'week', text: this.$t('common.noun.timePeriod.weeks') },
					{ value: 'month', text: this.$t('common.noun.timePeriod.months') },
				],
			},
			rules: {
				makerAssetAddress: [
					// Field is required
					val => (val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// maker asset and taker asset cannot be the same
					val => (!(this.input.makerAssetAddress && this.input.takerAssetAddress && this.input.makerAssetAddress === this.input.takerAssetAddress)) || this.$t('compNewOrderForm.err.tokenShouldBeDifferent'),
					// Balance should be greater than zero
					val => (this.account.balanceByAddress[val]) > 0 || this.$t('compNewOrderForm.err.noToken'),
					// Should have allowance
					val => (this.account.allowanceByAddress[val] > 0) || this.$t('compNewOrderForm.err.noAllowance'),
				],
				takerAssetAddress: [
					// Field is required
					val => (val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// maker asset and taker asset cannot be the same
					val => (!(this.input.makerAssetAddress && this.input.takerAssetAddress && this.input.makerAssetAddress === this.input.takerAssetAddress)) || this.$t('compNewOrderForm.err.tokenShouldBeDifferent'),
				],
				makerAssetAmount: [
					// Field is required
					val => (val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired') + ' (' + this.$t('common.err.amount.max') + ': ' + formatAmountNumber(this.maxMakerAssetAmount) + ')',
					// Must be a number
					val => !isNaN(val) || this.$t('common.err.amount.mustNumber') + ' (' + this.$t('common.err.amount.max') + ': ' + formatAmountNumber(this.maxMakerAssetAmount) + ')',
					// Must greater than zero
					val => val > 0 || this.$t('common.err.amount.mustGreaterThanZero')+ ' (' + this.$t('common.err.amount.max') + ': ' + formatAmountNumber(this.maxMakerAssetAmount) + ')',
					// Must not greater than the current balance
					val => val <= this.account.balanceByAddress[this.input.makerAssetAddress] || this.$t('common.err.amount.insufficientBalance') + ' (' + this.$t('common.err.amount.max') + ': ' + formatAmountNumber(this.maxMakerAssetAmount) + ')',
					// Must not greater than the current allowance
					val => val <= this.account.allowanceByAddress[this.input.makerAssetAddress] || this.$t('common.err.amount.insufficientAllowance') + ' (' + this.$t('common.err.amount.max') + ': ' + formatAmountNumber(this.maxMakerAssetAmount) + ')',
					// Must not have too many decimals
					val => (countDecimals(val) <= config.inputAmountMaxDecimals) ||
								this.$t('common.err.amount.tooManyDecimals') + ' (' + this.$t('common.err.amount.max') + ': ' + formatAmountNumber(this.maxMakerAssetAmount) + ')',
				],
				takerAssetAmount: [
					// Field is required
					val => (val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// Must be a number
					val => !isNaN(val) || this.$t('common.err.amount.mustNumber'),
					// Must greater than zero
					val => val > 0 || this.$t('common.err.amount.mustGreaterThanZero'),
					// Must not have too many decimals
					val => (countDecimals(val) <= config.inputAmountMaxDecimals) ||
								this.$t('common.err.amount.tooManyDecimals') + ": (" + this.$t('common.err.amount.max') + ': ' +
								config.inputAmountMaxDecimals + ')',
				],
				priceMakerPerTaker: [
					// Field is required
					val => (val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// Must be a number
					val => !isNaN(val) || this.$t('common.err.amount.mustNumber'),
					// Must greater than zero
					val => val > 0 || this.$t('common.err.amount.mustGreaterThanZero'),
					// Must not have too many decimals
					val => (countDecimals(val) <= config.inputAmountMaxDecimals) ||
								this.$t('common.err.amount.tooManyDecimals') + ": (" + this.$t('common.err.amount.max') + ': ' +
								config.inputAmountMaxDecimals + ')',
				],
				priceTakerPerMaker: [
					// Field is required
					val => (val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// Must be a number
					val => !isNaN(val) || this.$t('common.err.amount.mustNumber'),
					// Must greater than zero
					val => val > 0 || this.$t('common.err.amount.mustGreaterThanZero'),
					// Must not have too many decimals
					val => (countDecimals(val) <= config.inputAmountMaxDecimals) ||
								this.$t('common.err.amount.tooManyDecimals') + ": (" + this.$t('common.err.amount.max') + ': ' +
								config.inputAmountMaxDecimals + ')',
				],
				takerAddress: [
					// Required if restriction is ste
					val => (!this.input.restrictTaker || (val !== null && val !== undefined && val !== '')) || this.$t('common.phrase.fieldIsRequired'),
					// Must be a valid ERC20 address
					val => Web3Wrapper.isAddress(val) || this.$t('compAddTokenTracking.searchErrInvalidAddress'),
					// Must not been added already
					val => val && val.toLowerCase() !== this.myAddress.toLowerCase() || this.$t('common.err.address.ownAdd'),
				],
				expirationTime: [
					// Field is required
					val => (this.input.expirationTimeInputMethod === 'use-picker' && val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// Must be a future date
					val => getCurrentUnixTime() < getUnixTimeFromISODate(val) || this.$t('common.err.time.mustBeFuture'),
				],
				expirationSelectedNum: [
					val => (this.input.expirationTimeInputMethod === 'enter-period' && val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// Must be a number
					val => !isNaN(val) || this.$t('common.err.amount.mustNumber'),
					// Must greater than zero
					val => val > 0 || this.$t('common.err.amount.mustGreaterThanZero'),
				],
			},
			preSelectedMakerTokenInfo: null,
			preSelectedTakerTokenInfo: null,
			inputHasError: false,
			orderHash: null,
			initializationDone: false,
			preparingOrder: false,
			loading: false,
			showForm: false,
			showReview: false,
			waitingForNetwork: false,
			showResult: false,
			success: false,
			error: null,
			makerAddingNew: false,
			takerAddingNew: false,
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			web3Wrapper: 'getWeb3Wrapper',
			providerEngine: 'getProviderEngine',
			contractWrappers: 'getContractWrappers',
			contractAddresses: 'getContractAddresses',
			networkConfig: 'getNetworkConfig',
		}),
		maxMakerAssetAmount: function () {
			if (this.account.allowanceByAddress[this.input.makerAssetAddress] > 0) {
				const balance = this.account.balanceByAddress[this.input.makerAssetAddress]
				const allowance = this.account.allowanceByAddress[this.input.makerAssetAddress]
				if (allowance > balance) {
					return balance
				}
				else {
					return allowance
				}
			}
			else {
				return 0
			}
		},
		priceDisplayOptions: function () {
			let options = []
			if (this.input.makerAssetAddress && this.input.takerAssetAddress && this.makerAssetInfo && this.takerAssetInfo) {
				options = [
					{
						text: this.$t('common.orderForm.label.enterPriceAs') + ': 1 ' + this.takerAssetInfo.symbol + ' = ? ' + this.makerAssetInfo.symbol,
						value: 'maker-per-taker'
					},
					{
						text: this.$t('common.orderForm.label.enterPriceAs') + ': 1 ' + this.makerAssetInfo.symbol + ' = ? ' + this.takerAssetInfo.symbol,
						value: 'taker-per-maker'
					},
				]
			}
			return options
		},
		expirationTimeTextFieldConfig: function () {
			return {
				hint: this.$t('common.orderForm.label.now') + ': ' + this.inputOptions.currentTimeDisplay,
				persistentHint: true,
				outlined: true,
				dense: true,
				rules: this.rules.expirationTime,
				'append-icon': 'mdi-calendar',
			}
		},
		expirationDatePickerConfig: function () {
			return {
				color: "success",
				headerColor: "success",
				min: this.inputOptions.minExpirationTime,
				locale: localStorage.getItem(config.localStorageKey.locale) || config.defaultLocale
			}
		},
		expirationTimePickerConfig: function () {
			return {
				color: "success",
				headerColor: "success",
				locale: localStorage.getItem(config.localStorageKey.locale) || config.defaultLocale
			}
		},
		ZRXToken: function () {
			return this.tokenInfo.ZRXToken
		},
		preSelectedMakerTokenAddress: function () {
			if (this.tokenselection && this.tokenselection.makerAssetAddress) {
				// this.input.makerAssetAddress = this.tokenselection.makerAssetAddress
				return this.tokenselection.makerAssetAddress
			}
			else {
				return null
			}
		},
		preSelectedTakerTokenAddress: function () {
			if (this.tokenselection && this.tokenselection.takerAssetAddress) {
				// this.input.takerAssetAddress = this.tokenselection.takerAssetAddress
				return this.tokenselection.takerAssetAddress
			}
			else {
				return null
			}
		},
		inputComplete: function () {

			let expirationTimeComplete = false
			if (this.input.expirationTimeInputMethod === 'enter-period') {
				if (this.input.expirationSelected.number) {
					expirationTimeComplete = true
				}
			}
			else if (this.input.expirationTimeInputMethod === 'use-picker') {
				if (this.input.expirationTimeFromPicker) {
					expirationTimeComplete = true
				}
			}

			if (this.input.makerAssetAddress && this.input.takerAssetAddress
				&& this.input.makerAssetAmount && this.input.takerAssetAmount
				&& expirationTimeComplete ) {
				return true
			}
			else {
				return false
			}
		},
		makerAssetInfo: function () {
			if (this.input.makerAssetAddress) {
				const tokenList = [ ...this.account.trackedTokens, ...this.tokenInfo.tradingPairBaseList ]
				const trackedTokenInfo = findTokenByAddress(tokenList, this.input.makerAssetAddress)
				if (trackedTokenInfo) {
					return trackedTokenInfo
				}
				else {
					if (this.preSelectedMakerTokenInfo && this.preSelectedMakerTokenInfo.address === this.input.makerAssetAddress) {
						return this.preSelectedMakerTokenInfo
					}
					else {
						return null
					}
				}
			}
			else {
				return null
			}
		},
		takerAssetInfo: function () {
			if (this.input.takerAssetAddress) {
				const tokenList = [ ...this.account.trackedTokens, ...this.tokenInfo.tradingPairBaseList ]
				const trackedTokenInfo = findTokenByAddress(tokenList, this.input.takerAssetAddress)
				if (trackedTokenInfo) {
					return trackedTokenInfo
				}
				else {
					if (this.preSelectedTakerTokenInfo && this.preSelectedTakerTokenInfo.address === this.input.takerAssetAddress) {
						return this.preSelectedTakerTokenInfo
					}
					else {
						return null
					}
				}
			}
			else {
				return null
			}
		},
		expirationTimeDisplay: function () {
			if (this.input.expirationTime) {
				const expirationUnixTime = getUnixTimeFromISODate(this.input.expirationTime)
				return showDateTime(expirationUnixTime * 1000)
			}
			else {
				return ''
			}
		},
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount', 'getTokenInfoByAddress', 'loadRelayerInfo', 'updateAccountForToken', 'parseSignedOrder']),

		/* ------------------------------------------------------ */
		async init () {
			this.orderData = null
			this.signedOrder = null
			this.input.makerAddress = this.network.userAccount
			this.input.takerAddress = null
			this.input.senderAddress = NULL_ADDRESS
			this.input.feeRecipientAddress = NULL_ADDRESS
			this.input.makerAssetAddress = null
			this.input.takerAssetAddress = null
			this.input.exchangeAddress = this.network.contractAddresses.exchange
			this.input.makerFee = ZERO
			this.input.takerFee = ZERO
			this.input.makerAssetAmount = null
			this.input.takerAssetAmount = null
			this.input.expirationTime = null
			this.input.restrictTaker = false
			this.input.priceTakerPerMaker = null
			this.input.priceMakerPerTaker = null

			this.inputOptions.minExpirationTime = (new Date()).toISOString()
			this.updateTimes()

			// Being Pre Selected Maker or Takers
			if (this.preSelectedMakerTokenAddress) {
				this.preSelectedMakerTokenInfo = await this.getTokenInfoByAddress(this.preSelectedMakerTokenAddress)
				const balance = this.account.balanceByAddress[this.preSelectedMakerTokenAddress]
				const allowance = this.account.allowanceByAddress[this.preSelectedMakerTokenAddress]
				if (balance === undefined || balance === null || allowance === undefined || allowance === null) {
					// console.log('will load token balance and allowance for ' + this.preSelectedMakerTokenInfo.symbol)
					await this.updateAccountForToken(this.preSelectedMakerTokenInfo)
				}
				if (balance > 0 && allowance > 0) {
					this.input.makerAssetAddress = this.preSelectedMakerTokenAddress
				}
			}
			if (this.preSelectedTakerTokenAddress) {
				this.preSelectedTakerTokenInfo = await this.getTokenInfoByAddress(this.preSelectedTakerTokenAddress)
				const balance = this.account.balanceByAddress[this.preSelectedTakerTokenAddress]
				const allowance = this.account.allowanceByAddress[this.preSelectedTakerTokenAddress]
				if (balance === undefined || balance === null || allowance === undefined || allowance === null) {
					// console.log('will load token balance and allowance for ' + this.preSelectedTakerTokenInfo.symbol)
					await this.updateAccountForToken(this.preSelectedTakerTokenInfo)
				}
				this.input.takerAssetAddress = this.preSelectedTakerTokenAddress
			}

			this.getTokenSelectOptions()

			this.orderHash = null
			this.showResult = false
			this.showForm = true
			this.showReview = false
			this.preparingOrder = false
			this.loading = false
			this.waitingForNetwork = false
			this.success = false
			this.error = null

			this.loopJob = setInterval(this.updateTimes, 5000)

			this.initializationDone = true
		},

		getTokenSelectOptions () {
			// console.log('getTokenSelectOptions')
			// this.input.makerAssetAddress = null
			// this.input.takerAssetAddress = null
			this.inputOptions.makerAssetAddress = []
			this.inputOptions.takerAssetAddress = []
			const tokenList = [ ...this.account.trackedTokens, ...this.tokenInfo.tradingPairBaseList ]
			if (this.preSelectedMakerTokenAddress) {
				if (!findTokenByAddress(tokenList, this.preSelectedMakerTokenAddress)) {
					tokenList.push(this.preSelectedMakerTokenInfo)
				}
			}
			if (this.preSelectedTakerTokenAddress) {
				if (!findTokenByAddress(tokenList, this.preSelectedTakerTokenAddress)) {
					tokenList.push(this.preSelectedTakerTokenInfo)
				}
			}
			tokenList.sort((a,b) => { return a.symbol > b.symbol ? 1 : -1 })

			// const addtionalOpts = [
			// 	{ value: '--ACTION_ADD--', text: '+ ' + this.$t('common.phrase.addNewToken') }
			// ]
			// const addtionalOpts = []
			// if (this.allowaddtoken) {
			// 	for (let opt of addtionalOpts) {
			// 		this.inputOptions.makerAssetAddress.push(opt)
			// 		this.inputOptions.takerAssetAddress.push(opt)
			// 	}
			// }

			const seen = {}
			for (let token of tokenList) {
				const symbol = token.symbol
				const address = token.address
				if (seen[address]) {
					continue
				}
				seen[address] = true
				// console.log('get selection for: ' + symbol + ' ' + address)
				let balance = formatAmountNumber(this.account.balanceByAddress[address], 4)
				let allowance = formatAmountNumber(this.account.allowanceByAddress[address], 4)
				let makerOption = {
					value: address,
					text: symbol + ' (' + token.name + ')',
					balance: balance,
					allowance: allowance > 0,
					disabled: !balance  || !allowance
				}
				this.inputOptions.makerAssetAddress.push(makerOption)
				let takerOption = {
					value: address,
					text: symbol + ' (' + token.name + ')',
					balance: balance,
					allowance: allowance > 0,
				}
				this.inputOptions.takerAssetAddress.push(takerOption)
			}

			// if (this.allowaddtoken) {
			// 	for (let opt of addtionalOpts) {
			// 		this.inputOptions.makerAssetAddress.push(opt)
			// 		this.inputOptions.takerAssetAddress.push(opt)
			// 	}
			// }

		},

		formatAmountNumber: formatAmountNumber,

		formatAllowanceNumber: formatAllowanceNumber,

		handleNewTokenTracking (newToken) {
			this.getTokenSelectOptions()
			if (this.makerAddingNew) {
				this.input.makerAssetAddress = newToken.address
			}
			if (this.takerAddingNew) {
				this.input.takerAssetAddress = newToken.address
			}
		},

		handleAddTokenModalHidden () {
			this.getTokenSelectOptions()
			if (this.input.makerAssetAddress && this.input.makerAssetAddress == '--ACTION_ADD--') {
				this.input.makerAssetAddress = null
			}
			if (this.input.takerAssetAddress && this.input.takerAssetAddress == '--ACTION_ADD--') {
				this.input.takerAssetAddress = null
			}
		},

		handleMakerTokenChange () {
			if (this.input.takerAssetAddress) {
				this.$refs.form.validate()
			}
			this.input.makerAssetAmount = null
			this.input.takerAssetAmount = null
			this.input.expirationTime = null
			this.input.restrictTaker = false
			this.input.priceTakerPerMaker = null
			this.input.priceMakerPerTaker = null
		},

		handleTakerTokenChange () {
			if (this.input.makerAssetAddress) {
				this.$refs.form.validate()
			}
			this.input.makerAssetAmount = null
			this.input.takerAssetAmount = null
			this.input.expirationTime = null
			this.input.restrictTaker = false
			this.input.priceTakerPerMaker = null
			this.input.priceMakerPerTaker = null
		},

		formatAssetAmount (amount, tokenInfo, defaultDecimals = 6) {
			const decimals = Math.min(tokenInfo.decimals, defaultDecimals)
			return formatAmountNumber(amount, decimals)
		},

		hasNoneZeroValidInput (field) {
			const val = this.input[field]
			if (val === null || val === undefined || val === '') {
				return false
			}
			return true
		},

		handlePriceTakerPerMakerChange () {
			// console.log('handlePriceTakerPerMakerChange')
			if (this.hasNoneZeroValidInput('priceTakerPerMaker')) {
				const myValue = this.input.priceTakerPerMaker
				const otherValue = 1 / myValue
				// this.input.priceTakerPerMaker = formatAmountNumber(myValue)
				this.input.priceMakerPerTaker = formatAmountNumber(otherValue)
				if (this.input.makerAssetAmount || this.input.takerAssetAmount) {
					if (this.input.makerAssetAmount && !this.input.takerAssetAmount) {
						const amount = this.input.makerAssetAmount * myValue
						this.input.takerAssetAmount = this.formatAssetAmount(amount, this.takerAssetInfo)
					}
					else if (this.input.takerAssetAmount && !this.input.makerAssetAmount) {
						const amount = this.input.takerAssetAmount / myValue
						this.input.makerAssetAmount = this.formatAssetAmount(amount, this.makerAssetInfo)
					}
					else {
						const amount = this.input.makerAssetAmount * myValue
						this.input.takerAssetAmount = this.formatAssetAmount(amount, this.takerAssetInfo)
					}
				}
			}
			else {
				this.input.priceMakerPerTaker = null
				this.input.takerAssetAmount = null
			}
		},

		handlePriceMakerPerTakerChange () {
			// console.log('handlePriceMakerPerTakerChange')
			if (this.hasNoneZeroValidInput('priceMakerPerTaker')) {
				const myValue = this.input.priceMakerPerTaker
				const otherValue = 1 / myValue
				// this.input.priceMakerPerTaker = formatAmountNumber(myValue)
				this.input.priceTakerPerMaker = formatAmountNumber(otherValue)
				// this.input.priceTakerPerMaker = 1 / myValue
				if (this.input.makerAssetAmount || this.input.takerAssetAmount) {
					if (this.input.makerAssetAmount && !this.input.takerAssetAmount) {
						const amount = this.input.makerAssetAmount / myValue
						this.input.takerAssetAmount = this.formatAssetAmount(amount, this.takerAssetInfo)
					}
					else if (this.input.takerAssetAmount && !this.input.makerAssetAmount) {
						const amount = this.input.takerAssetAmount * myValue
						this.input.makerAssetAmount = this.formatAssetAmount(amount, this.makerAssetInfo)
					}
					else {
						const amount = this.input.makerAssetAmount / myValue
						this.input.takerAssetAmount = this.formatAssetAmount(amount, this.takerAssetInfo)
					}
				}
			}
			else {
				this.input.priceTakerPerMaker = null
				this.input.takerAssetAmount = null
			}
		},

		handleMakerAssetAmountChange () {
			// console.log('handleMakerAssetAmountChange')
			if (this.hasNoneZeroValidInput('makerAssetAmount')) {
				const myValue = this.input.makerAssetAmount
				if (this.input.priceTakerPerMaker || this.input.takerAssetAmount) {
					if (this.input.priceTakerPerMaker && !this.input.takerAssetAmount) {
						const amount = this.input.priceTakerPerMaker * myValue
						this.input.takerAssetAmount = this.formatAssetAmount(amount, this.takerAssetInfo)
						// this.input.takerAssetAmount = amount
					}
					else if (!this.input.priceTakerPerMaker && this.input.takerAssetAmount) {
						const price = this.input.takerAssetAmount / myValue
						this.input.priceTakerPerMaker = price
						this.input.priceMakerPerTaker = 1 / price
					}
					else {
						const amount = this.input.priceTakerPerMaker * myValue
						// this.input.takerAssetAmount = amount
						this.input.takerAssetAmount = this.formatAssetAmount(amount, this.takerAssetInfo)
					}
				}
			}
			else {
				this.input.takerAssetAmount = null
			}
		},

		handleTakerAssetAmountChange () {
			// console.log('handleTakerAssetAmountChange')
			if (this.hasNoneZeroValidInput('takerAssetAmount')) {
				const val = this.input.takerAssetAmount
				if (this.input.priceMakerPerTaker || this.input.makerAssetAmount) {
					if (this.input.priceMakerPerTaker && !this.input.makerAssetAmount) {
						const amount = this.input.priceMakerPerTaker * val
						this.input.makerAssetAmount = this.formatAssetAmount(amount, this.makerAssetInfo)
						// this.input.makerAssetAmount = amount
					}
					else if (!this.input.priceMakerPerTaker && this.input.makerAssetAmount) {
						const newVal = this.input.makerAssetAmount / val
						this.input.priceMakerPerTaker = newVal
					}
					else {
						const amount = this.input.priceMakerPerTaker * val
						this.input.makerAssetAmount = this.formatAssetAmount(amount, this.makerAssetInfo)
						// this.input.makerAssetAmount = amount
					}
				}
			}
			else {
				this.input.makerAssetAmount = null
			}
		},

		handleTakerRestrictionChange () {
			// console.log('handleTakerRestrictionChange')
			if (this.input.restrictTaker === false) {
				this.input.taker = null
			}
		},

		showSetProxyAllowanceForm(token) {
			// console.log('showSetProxyAllowanceForm', token)
			this.$refs.setProxyAllowanceForm.showForm(token)
		},

		isAllowanceError(errText) {
			if (!errText) {
				return false
			}
			const text = errText.toLowerCase()
			return (text.includes('allowance'))
		},

		showOrderReview () {
			this.showReview = true
			this.prepareNewOrder()
		},

		hideOrderReview () {
			this.showReview = false
		},

		showMakerFee: function () {
			// console.log('makerFee', this.input.makerFee)
			if (this.input.makerFee && this.ZRXToken) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.input.makerFee), this.ZRXToken.decimals).toNumber()
			}
			else {
				return 0
			}
		},

		showTakerFee: function () {
			// console.log('takerFee', this.input.takerFee)
			if (this.input.takerFee && this.ZRXToken) {
				return Web3Wrapper.toUnitAmount(new BigNumber(this.input.takerFee), this.ZRXToken.decimals).toNumber()
			}
			else {
				return 0
			}
		},

		changeExpirationTimeInputMethod: function (method) {
			this.input.expirationTimeInputMethod = method
			if (method === 'enter-period') {
				this.input.expirationTimeFromPicker = null
			}
			else if (method === 'use-picker') {
				this.input.expirationSelected.number = null
			}
		},

		/* ------------------------------------------------------ */
		async prepareNewOrder () {

			this.preparingOrder = true

			// make sure in all lower case
			const addressList = ['makerAddress', 'takerAddress', 'senderAddress', 'feeRecipientAddress', 'makerAssetAddress', 'takerAssetAddress', 'exchangeAddress']
			for (let key of addressList) {
				if (this.input[key]) {
					this.input[key] = this.input[key].toLowerCase()
				}
			}

			const inputList = ['makerAddress', 'takerAddress', 'senderAddress', 'feeRecipientAddress', 'exchangeAddress', 'makerFee', 'takerFee', 'makerAssetAmount', 'takerAssetAmount']

			const order = {}
			order.chainId = this.network.id
			for (let key of inputList) {
				order[key] = this.input[key]
			}

			if (this.input.restrictTaker === false) {
				order.takerAddress = NULL_ADDRESS
			}

			order.senderAddress = NULL_ADDRESS

			const makerAssetInfo = this.makerAssetInfo
			const takerAssetInfo = this.takerAssetInfo

			if (!makerAssetInfo.name) {
				throw new Error ("Error getting token info for " + this.input.makerAssetAddress)
			}
			if (!takerAssetInfo.name) {
				throw new Error ("Error getting token info for " + this.input.takerAssetAddress)
			}

			try {

				order.makerAssetData = await this.contractWrappers.devUtils.encodeERC20AssetData(this.input.makerAssetAddress).callAsync();
				order.takerAssetData = await this.contractWrappers.devUtils.encodeERC20AssetData(this.input.takerAssetAddress).callAsync();

				if (this.input.expirationTimeInputMethod === 'use-picker') {
					const expirationUnixTime = getUnixTimeFromISODate(this.input.expirationTimeFromPicker)
					order.expirationTimeSeconds = new BigNumber(expirationUnixTime)
				}
				else if (this.input.expirationTimeInputMethod === 'enter-period') {
					const currentUnixTime = getCurrentUnixTime()
					const num = this.input.expirationSelected.number
					const period = this.input.expirationSelected.period
					let unitTimeInSec = null
					if (period === 'min') {
						unitTimeInSec = 60
					}
					else if (period === 'hour') {
						unitTimeInSec = 60 * 60
					}
					else if (period === 'day') {
						unitTimeInSec = 60 * 60 * 24
					}
					else if (period === 'week') {
						unitTimeInSec = 60 * 60 * 24 * 7
					}
					else if (period === 'month') {
						unitTimeInSec = 60 * 60 * 24 * 30.5
					}
					else {
						throw new Error ('Invalid time period: ' + period)
					}
					const expirationUnixTime = parseInt(currentUnixTime + num * unitTimeInSec)
					order.expirationTimeSeconds = new BigNumber(expirationUnixTime)
				}
				else {
					throw new Error ("error calculating expiration time")
				}

				order.makerAssetAmount = Web3Wrapper.toBaseUnitAmount(new BigNumber(order.makerAssetAmount), makerAssetInfo.decimals)
				order.takerAssetAmount = Web3Wrapper.toBaseUnitAmount(new BigNumber(order.takerAssetAmount), takerAssetInfo.decimals)

				order.salt = generatePseudoRandomSalt()

				// console.log(order)

				// Call own relayer to get order config
				const httpClient = new HttpClient(this.networkConfig.backendSRAHttpURL)
				const orderConfigRequest = {
					chainId: order.chainId,
					exchangeAddress: order.exchangeAddress,
					makerAddress: order.makerAddress,
					takerAddress: order.takerAddress,
					makerAssetAmount: order.makerAssetAmount,
					takerAssetAmount: order.takerAssetAmount,
					makerAssetData: order.makerAssetData,
					takerAssetData: order.takerAssetData,
					expirationTimeSeconds: order.expirationTimeSeconds
				}
				const ownRelayerOrderConfig = await httpClient.getOrderConfigAsync(
					orderConfigRequest
				)
				// console.log(ownRelayerOrderConfig)

				order.senderAddress = ownRelayerOrderConfig.senderAddress
				order.feeRecipientAddress = ownRelayerOrderConfig.feeRecipientAddress
				order.makerFee = new BigNumber(ownRelayerOrderConfig.makerFee)
				order.takerFee = new BigNumber(ownRelayerOrderConfig.takerFee)
				order.makerFeeAssetData = ownRelayerOrderConfig.makerFeeAssetData
				order.takerFeeAssetData = ownRelayerOrderConfig.takerFeeAssetData

				// console.log(order)

				this.orderData = order
				this.parsedOrder = await this.parseSignedOrder(order)

			} catch (err) {
				console.log(err)
				this.error = err.toString()
				// this.$parent.$emit("errorNotification", this.$t('common.err.generic'))
			} finally {
				this.preparingOrder = false
			}

		},

		async generateNewOrder () {

			this.loading = true
			this.hideOrderReview()

			this.showForm = false
			this.waitingForNetwork = true

			const order = { ...this.orderData }

			try {

				// Sign order with wallet
				const signedOrder = await signatureUtils.ecSignOrderAsync(this.providerEngine, order, order.makerAddress);

				// validate order
				const [
					{ orderStatus, orderHash },
					remainingFillableAmount,
					isValidSignature,
				] = await this.contractWrappers.devUtils.getOrderRelevantState(signedOrder, signedOrder.signature).callAsync();
				// console.log('orderSatus: ' + orderStatus)
				// console.log('orderHash: ' + orderHash)
				// console.log('remainingFillableAmount: ' + remainingFillableAmount)
				// console.log('isValidSignature: ' + isValidSignature)

				// Order is fillable
				if (orderStatus === OrderStatus.Fillable && remainingFillableAmount.isGreaterThan(0) && isValidSignature) {

					this.orderHash = orderHash

					// submit to own backend
					const httpClient = new HttpClient(this.networkConfig.backendSRAHttpURL)
					await httpClient.submitOrderAsync(signedOrder)

					// submit to mesh
					const meshHttpClient = new HttpClient(this.networkConfig.meshSRAHttpURL)
					await meshHttpClient.submitOrderAsync(signedOrder)

					// console.log(orderSubmitStatus)
					this.$emit('new-order-form-success')

				}
				else {
					console.log('order failed checking.')
					this.error = this.$t('compNewOrderForm.err.orderUnfillable')
				}

			} catch (err) {

				console.log(err)
				this.error = err.toString()
				// this.$parent.$emit("errorNotification", this.$t('common.err.generic'))

			} finally {

				this.showResult = true
				this.loading = false
				this.waitingForNetwork = false

			}

		},

		emitCloseModal () {
			this.$emit('new-order-form-close-modal')
		},

		/* ------------------------------------------------------ */
		showAddTokenTrackingForm () {
			this.$refs.addTokenTrackingForm.showForm()
		},

		copyToClipboard (selector) {
			const element = document.getElementById(selector)
			const range = document.createRange()
			range.selectNode(element)
			window.getSelection().addRange(range)
			document.execCommand('copy')
		},

		updateTimes () {
			const currentUnixTime = getCurrentUnixTime()
			this.currentUnixTime = currentUnixTime
			// console.log(currentUnixTime)
			this.inputOptions.currentTimeDisplay = showDateTime(currentUnixTime * 1000)
			// console.log('inputOptions', this.inputOptions)
		}

	},
	created () {
		this.init()
	},
	beforeDestroy () {
		if (this.loopJob) {
			clearInterval(this.loopJob)
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
